import React from 'react'
import PropTypes from 'prop-types'
import 'styles/location-finder.css'
import Utils from 'common/utils';
import LocationStringManager from 'manager/locationStringManager'
import WeatherParams from 'models/weatherParams';
import Constants from 'common/constants'



var defaultLocationSuggestions = []
export default class SearchResultsView extends React.Component {
    constructor(props) {
        super(props)
        this.populatePopularPlaces()
        this.state = {
            locationData: this.props.locationResults,
            searchQuery: this.props.searchQuery,
        }
    }

    componentWillReceiveProps(newProps) {
        if (
            newProps.locationResults !== this.props.locationResults ||
            newProps.searchQuery !== this.props.searchQuery
        ) {
            this.setState({
                locationData: newProps.locationResults,
                searchQuery: newProps.searchQuery,
            })
        }
    }

    render() {
        console.log("[RESULTS] Query - ", this.state.searchQuery)
        let locationsList = this.state.locationData
        if (Utils.isNull(locationsList)) {
            locationsList = []
        }
        console.log("[RESULTS] Num results - ", locationsList.length)

        if (Utils.isEmptyStr(this.state.searchQuery) && locationsList.length === 0) {
            locationsList = defaultLocationSuggestions;
        }
        if (false === Utils.isEmptyStr(this.state.searchQuery) && locationsList.length === 0) {
            return (
                <div className="search-results-empty">
                    No results for "{this.state.searchQuery}"
                </div>
            )
        }

        return (
            <div className="search-options-wrapper">
                {
                    locationsList.map((locData, locIndex) => {
                        let locStr = Utils.formatLatLon(locData.latitude, locData.longitude)
                        let locArea = locData.area
                        if (false === Utils.isNull(locArea)) {
                            locStr = LocationStringManager.getLocationString(
                                locArea.area,
                                locArea.city,
                                locStr,
                            )

                            if(false === Utils.isNull(locData.country)){
                                locStr=locStr+", "+locData.country

                            }
                        }
                        return (
                            <div className="search-options" key={locIndex} onClick={() => {
                                this.props.onSelectedLocationCallback(locData)
                            }}>
                                {locStr}
                            </div>
                        )
                    })
                }
            </div>
        )
    }

    /**
     * Top 10 popular/populous places in USA as per wikipedia
     */
    populatePopularPlaces() {
        var weatherDataNewYork = new WeatherParams("40.6943", "-73.9249", null, "New York", "New York", null, Constants.WEATHER_SRC.MANUAL);
        var weatherDataLosAngeles = new WeatherParams("34.1139", "-118.4068", null, "Los Angeles", "California", null, Constants.WEATHER_SRC.MANUAL);
        var weatherDataChicago = new WeatherParams("41.8373", "-87.6861", null, "Chicago", "Illinois", null, Constants.WEATHER_SRC.MANUAL);
        var weatherDataHouston = new WeatherParams("33.8963", "-89.0032", null, "Houston", "Texas", null, Constants.WEATHER_SRC.MANUAL);
        var weatherDataPhoenix = new WeatherParams("42.2748", "-122.8151", null, "Phoenix", "Arizona", null, Constants.WEATHER_SRC.MANUAL);
        var weatherDataPhiladelphia = new WeatherParams("32.7761", "-89.1221", null, "Philadelphia", "Pennsylvania", null, Constants.WEATHER_SRC.MANUAL);
        var weatherDataSanAntonio = new WeatherParams("37.0208", "-106.0281", null, "San Antonio", "Texas", null, Constants.WEATHER_SRC.MANUAL);
        var weatherDataSanDiego = new WeatherParams("32.8312", "-117.1226", null, "San Diego", "California", null, Constants.WEATHER_SRC.MANUAL);
        var weatherDataDallas = new WeatherParams("43.2379", "-99.5175", null, "Dallas", "Texas", null, Constants.WEATHER_SRC.MANUAL);
        var weatherDataSanJose = new WeatherParams("32.8169", "-109.5957", null, "San Jose", "California", null, Constants.WEATHER_SRC.MANUAL);
        defaultLocationSuggestions=[]
        defaultLocationSuggestions.push(weatherDataNewYork);
        defaultLocationSuggestions.push(weatherDataLosAngeles);
        defaultLocationSuggestions.push(weatherDataChicago);
        defaultLocationSuggestions.push(weatherDataHouston);
        defaultLocationSuggestions.push(weatherDataPhoenix);
        defaultLocationSuggestions.push(weatherDataPhiladelphia);
        defaultLocationSuggestions.push(weatherDataSanAntonio);
        defaultLocationSuggestions.push(weatherDataSanDiego);
        defaultLocationSuggestions.push(weatherDataDallas);
        defaultLocationSuggestions.push(weatherDataSanJose);
    }
}

SearchResultsView.propTypes = {
    searchQuery: PropTypes.string,
    locationResults: PropTypes.array,
    onSelectedLocationCallback: PropTypes.func,
}


// WEBPACK FOOTER //
// ./src/components/locationFinder/searchResultsView.js